(function($, document, window, undefined) {

  function value_without_px_as_number(value_with_px) {
    value_with_px = value_with_px.slice(0,-2);
    value_with_px = parseInt(value_with_px);
    return value_with_px;
  }

  window.IPRedirect = {
    init: function(settings) {
      // Assignment
      var self = this;
        
      self.settings = settings;
      self.redirect = localStorage.getItem("location-redirect");
      self.messageWrap = $("#location-redirect-message");
      self.textMessage = $('.text-message', self.messageWrap);
      self.currentCountry = $('.current-country', self.messageWrap);
      self.RedirectMe = $('.redirect-me', self.messageWrap);
      self.closeBtn = $('.close-redirect-btn', self.messageWrap);
      self.newStore = $('.new-store', self.messageWrap);

      //Secondary - this is where the region and url are defined
      self.catchAllCountries = settings["redirect_catch_all_countries"];
      self.catchAllURL = settings["redirect_catch_all_url"];
      self.catchAllName = settings["redirect_catch_all_name"];
      self.catchAllMessage = settings["redirect_to_message"];
      self.catchAllApprove = settings["redirect_approve"];
      self.catchAllDecline = settings["redirect_decline"];

      self.catchAllCountriesSec = settings["redirect_catch_all_countries_secondary"];
      self.catchAllURLSec = settings["redirect_catch_all_url_secondary"];
      self.catchAllNameSec = settings["redirect_catch_all_name_secondary"];
      self.catchAllMessageSec = settings["redirect_to_message_secondary"];
      self.catchAllApproveSec = settings["redirect_approve_secondary"];
      self.catchAllDeclineSec = settings["redirect_decline_secondary"];

      self.forceRedirect = settings["redirect_force"] ? true : false;
      self.countryTranslations = {
        "Sweden": "Sverige"
      };
      self.domain = "https://server.shortcodesforshopify.com/json/?callback=?";
      self.redirects = [];
      self.urlMap = {};
      self.urlMapSec = {};
      self.location = {};

      // Preparation
      self.loadRedirects(settings);
      self.mapURLs(self.redirects, "::");
      self.redirect = (typeof self.redirect == "string") ? JSON.parse(self.redirect) : {shown: false, date: null};
      self.redirect.shown = self.getIsRedirectShown();

      // Initialization successful
      return true;
    },
    run: function() {
      var self = this;

      var successCallback = ( self.forceRedirect ) ? self.fetchAndRedirectOnResponse : self.fetchAndShowRedirect,
        activateRedirect = ( ! self.redirect.shown || self.forceRedirect ) ? true : false;

      if( activateRedirect ) {
        self.makeServerCall( self.fetchLocationInfoAndRunCallback, successCallback );

        if( ! self.forceRedirect )
          self.bindRedirect();
      }
    },
    loadRedirects: function(settings) {
      var self = this;
      for(var i = 1; i < 11; ++i) {
        var name = "redirect_" + i;

        self.redirects.push(settings[name]);
      }
    },
    mapURLs: function(stringList, splitter) {
      var self = this;
      for(var i = 0; i < stringList.length; ++i) {
        if( stringList[i] && stringList[i] != "") {
          var splitString = stringList[i].split(splitter);

          if(splitString[2].indexOf("http://") === -1 && splitString[1].indexOf("https://") === -1 ) {
            splitString[2] = "http://" + splitString[2];
          }

          self.urlMap[splitString[0]] = {
            "name": splitString[1],
            "url": splitString[2]
          };
        }
      }

      if(self.catchAllCountries.length > 0) {
        var countries = self.catchAllCountries.split(/[\s,]+/);

        for(var i = 0; i < countries.length; ++i) {
          self.urlMap[ countries[i] ] = {
            "name": self.catchAllName,
            "url": self.catchAllURL,
            "message": self.catchAllMessage,
            "approve": self.catchAllApprove,
            "decline": self.catchAllDecline
          }
        }
      }

      if(self.catchAllCountriesSec.length > 0) {
        var countriesSec = self.catchAllCountriesSec.split(/[\s,]+/);

        for(var i = 0; i < countriesSec.length; ++i) {
          self.urlMapSec[ countriesSec[i] ] = {
            "name": self.catchAllNameSec,
            "url": self.catchAllURLSec, 
            "message": self.catchAllMessageSec,
            "approve": self.catchAllApproveSec,
            "decline": self.catchAllDeclineSec
          }
        }
      }

      return self.urlMap;
    },
    getIsRedirectShown: function() {
      var self = this,
        today = new Date(),
        prevDate = new Date(self.redirect.date),
        dayLength = 1000 * 24 * 60 * 60, // in milliseconds
        diffDate = today - prevDate;

      // display query again if localStorage is older than 30 days
      if( diffDate / dayLength > 30 )
        return false;

      return true;
    },
    makeServerCall: function( serverCall, callback ) {
      return serverCall(callback);
    },
    fetchLocationInfoAndRunCallback: function( successCallback ) {
      var self = IPRedirect;

      $.ajax( {
        url: self.domain,
        type: 'POST',
        dataType: 'jsonp',
        async: false,
        success: successCallback,
        error: successCallback
      });
    },
    fetchAndShowRedirect: function( location ) {
      var self = IPRedirect;
      self.location = location;
      var locationCountryCode = self.urlMap[location.country_code] ? self.urlMap[location.country_code] : self.urlMapSec[location.country_code];
      if (locationCountryCode !== undefined && locationCountryCode.url !== null) {
        var countryName = (self.countryTranslations[location.country_name]) ? self.countryTranslations[location.country_name] : location.country_name;
        self.currentCountry.text(countryName);
        //Secondary - this is where the store is populated
        self.newStore.text( locationCountryCode.name );
        self.textMessage.text(locationCountryCode.message);
        self.RedirectMe.attr("href", locationCountryCode.url);
        self.RedirectMe.text(locationCountryCode.approve);
        self.closeBtn.text(locationCountryCode.decline);
        //Altered - add extra padding to body
          var body_padding_top = $('body').css('padding-top');
          body_padding_top = value_without_px_as_number(body_padding_top);
          var message_height = $('#location-redirect-message').css('height');
          message_height = value_without_px_as_number(message_height);
          var body_displace = body_padding_top + message_height + 'px';
          $('body').css('padding-top', body_displace);
        //Altered
        self.messageWrap.show();
      }
    },
    fetchAndRedirectOnResponse: function( location ) {
      var self = IPRedirect;
      self.location = location;
      var locationCountryCode = self.urlMap[location.country_code] ? self.urlMap[location.country_code] : self.urlMapSec[location.country_code];

      if(locationCountryCode.url != null) {
        window.location.assign(locationCountryCode.url);
      }
    },
    bindRedirect: function() {
      var self = this;

      // only save to local storage if the user doesn't want to be redirected.
      self.closeBtn.off().on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        self.messageWrap.hide();
        //Altered - remove extra padding on body
          var body_padding_top = $('body').css('padding-top');
          body_padding_top = value_without_px_as_number(body_padding_top);
          var message_height = $('#location-redirect-message').css('height');
          message_height = value_without_px_as_number(message_height);
          var body_displace = body_padding_top - message_height + 'px';
          $('body').css('padding-top', body_displace);
        //Altered
        self.saveRedirect();
      });

      self.RedirectMe.on("click", function(e) {
        e.stopPropagation();
      });
    },
    saveRedirect: function(key, val) {
      var redirect = {
        shown: true,
        date: Date()
      };
      localStorage.setItem("location-redirect", (JSON.stringify(redirect)));
    }
  };
})(jQuery, document, window);